import axios from 'axios';
import Vue from 'vue'

export default {

    getOrders(status, menuCode) {  
        return axios.get('/api/orders/list', {params:{status:status, menuCode:menuCode}})
        .then(response => {
           return response;
        })
    },

    getOrder(id) {  
        return axios.get('/api/orders/order', {params:{id:id}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    editOrderline(quantity, id, code) {  
        return axios.get('/api/orders/order/edit/orderline', {params:{quantity:quantity, id:id, code:code}})
        .then(response => {
            if (response && response.data) return response.data
        }).catch(error => {
            return Promise.reject(error);
        });
    },

    addOrderline(menuItemId, menuCode, tableNumber, code) {  
        return axios.get('/api/orders/order/add/orderline', {params:{menuItemId:menuItemId, menuCode:menuCode, tableNumber:tableNumber, code:code}})
        .then(response => {
            if (response && response.data) return response.data
        }).catch(error => {
            return Promise.reject(error);
        });
    },

    updateStatus(id, action) {  
        return axios.get('/api/orders/updateStatus', {params:{id:id, action:action}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    archivedAll(menuCode) {  
        return axios.get('/api/orders/archivedAll', {params:{menuCode:menuCode}})
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    submitOrder(newOrderRequest) {  
        const url = new URL(window.location.href);
        const did = url.searchParams.get('did');
        newOrderRequest.dataId = did;
        
        return axios.post('/api/orders/submit', newOrderRequest)
        .then(response => {
           return response;
        }).catch(error => {
            return Promise.reject(error);
        });

    },

    saveTableTransfer(orderId, targetTable) {  
        return axios.get('/api/orders/transfer-table', {params:{orderId:orderId, targetTable:targetTable}})
        .then(response => {
            if (response && response.data) return response.data
        })
    },
    
}

